import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CateringStateService } from 'libs/core/src/lib/state/catering.state.service';
import { AppService } from 'libs/core/src/lib/service/app.service';
import { StepsComponent } from 'libs/shared/src/lib/component/steps/steps.component';
import { environment } from 'apps/cinema1/src/environments/environment';
import { FlowService } from 'libs/core/src/lib/service/flow.service';
import { TitleService } from 'libs/core/src/lib/service/title.service';

@Component({ standalone: false, selector: 'app-steps', templateUrl: './steps.component.html' })
export class CustomStepsComponent extends StepsComponent implements OnInit, AfterViewChecked {
  constructor(
    protected translator: TranslateService,
    protected titleService: TitleService,
    protected flowService: FlowService,
    protected cateringStateService: CateringStateService,
    protected appService: AppService
  ) {
    super(environment, translator, titleService, flowService, cateringStateService, appService);
  }

  override addCateringOffset(): number {
    return this.step;
  }
}
